// 10. Core Vue Imports
import { createApp } from 'vue'
import App from './App.vue'

// font local import
import '@fontsource/roboto/100.css'  
import '@fontsource/roboto/300.css'  
import '@fontsource/roboto/400.css'  
import '@fontsource/roboto/500.css'  
import '@fontsource/roboto/700.css'  
import '@fontsource/roboto/900.css'  
import '@fontsource/noto-sans-mono/400.css'
import '@fontsource/noto-sans-mono/600.css'
import '@fontsource/noto-sans-mono/700.css'
import '@fontsource/noto-sans-mono/900.css'
import '@fontsource/material-icons'

import vuetify from './plugins/vuetify'
import { Core } from './plugins/jingraphics'
// import { Kim } from './plugins/kims'
import LibComponents from '../lib/jin'
import UIComponents from '../src/components'
// import KimLibComponents from '../../lib/kim'

// 20. Additional Plugins
import i18n from './i18n'
import axios from 'axios'
import VueCookies from 'vue3-cookies'
import { globalCookiesConfig } from 'vue3-cookies'
import { ModalDraggableMixin } from './mixins/modal.draggable.mixin'
import FileBrowserPlugin from './plugins/filebrowser'  // FileBrowser Plugin

// 30. Router & Store
import { sync } from 'vuex-router-sync'
import router from './router' // vue-router instance
import store from './store'   // vuex store instance

// import { loadFonts } from './plugins/webfontloader'
// loadFonts()

import '@/assets/stylus/jstyle.scss'
// Sync store with router
sync(store, router)

// 40. Cookies Configuration
const cookiesConfig = {
  expireTimes: '7d',
  path: '/',
  secure: true,
}

// 50. Create Vue Application
const app = createApp(App)

// 60. Use Plugins
app.use(router)
app.use(store)
app.use(i18n)
app.use(vuetify)
app.use(FileBrowserPlugin)  
app.use(VueCookies, cookiesConfig)
app.use(Core, {
  components: {
    ...LibComponents,
    ...UIComponents
  }
})
// app.use(Kim, {
//   components: {
//     ...KimLibComponents,
//   }
// })
app.mixin(ModalDraggableMixin)

// 70. Global Cookies Config
globalCookiesConfig({
  expireTimes: '7d',
})

// 80. Axios Configuration
axios.defaults.withCredentials = true
app.config.globalProperties.$__home = '/'
// 90. Mount Application
router.isReady().then(() => {
  app.mount('#app')
})